import React, {PureComponent} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './SendSMSConfirmationDialog.scss'
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";

export default class SendSMSConfirmationDialog extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {todayUsage: 0};
    }

    handleCancel() {
        if (this.props.onCancel)
            this.props.onCancel();
    }

    handleSend() {
        if (this.props.onSend)
            this.props.onSend();
    }

    render() {
        return (
            <Dialog
                className="sms-confirmation-dialog"
                open={this.props.open}
                onClose={this.handleCancel.bind(this)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">אישור שליחת SMS ללקוחות</DialogTitle>
                <DialogContent>
                    <div>
                        האם אתה בטוח שתרצה לשלוח הודעת SMS ללקוחות הבאים:
                        {
                            this.props.users.map((user, index) =>
                                <div key={user.id}>
                                    {index + 1}. {user.label}
                                </div>
                            )
                        }
                        <br/>
                        טקסט ההודעה:
                        <br/>
                        {this.props.message}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={this.handleCancel.bind(this)}>
                        בטל
                    </Button>
                    <Button variant="contained" color="primary" onClick={this.handleSend.bind(this)}>
                        שלח
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}